"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const mxp_schemas_1 = require("mxp-schemas");
const user_1 = require("../user");
var Routes;
(function (Routes) {
    Routes["MEMBERSHIP_FORM"] = "/membership/package";
    Routes["CENTER_MEMBERSHIP_FORM"] = "/center-membership/package";
    Routes["MY_RECEIPTS"] = "/profile/transactions";
})(Routes = exports.Routes || (exports.Routes = {}));
exports.getPathwayPathSlug = (pathway) => {
    const pathwayPathValue = {
        [mxp_schemas_1.MembershipTypes.Pathway.PQ]: 'pq',
        [mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L4]: 'apprentice-l4',
        [mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L7]: 'apprentice-l7',
        [mxp_schemas_1.MembershipTypes.Pathway.FLP]: 'flp',
    };
    return pathway ? pathwayPathValue[pathway] : 'pathway';
};
exports.getQualificationLevelPathSlug = (qualificationLevel) => {
    const qualificationLevelPathValue = {
        [mxp_schemas_1.MembershipTypes.CimaQualificationLevelPathValue.ManagementLevel]: 'management',
        [mxp_schemas_1.MembershipTypes.CimaQualificationLevelPathValue.OperationalLevel]: 'operational',
        [mxp_schemas_1.MembershipTypes.CimaQualificationLevelPathValue.StrategicLevel]: 'strategic',
        [mxp_schemas_1.MembershipTypes.CimaQualificationLevelPathValue.CertBa]: 'cert-ba',
        [mxp_schemas_1.MembershipTypes.CimaQualificationLevelPathValue.EPA4]: 'epa-4',
        [mxp_schemas_1.MembershipTypes.CimaQualificationLevelPathValue.EPA7]: 'epa-7',
        [mxp_schemas_1.MembershipTypes.CimaQualificationLevelPathValue.BusinessAndFinanceEssentialsCourse]: 'business',
    };
    return qualificationLevel ? qualificationLevelPathValue[qualificationLevel] : 'qualification';
};
exports.transformFirmMembershipToMembershipRoleId = (firmMembershipType) => { var _a; return (_a = Object.entries(user_1.contentSuppressMembershipMap).filter(membershipMap => {
    const [, roleId] = membershipMap;
    return Boolean(roleId.acronym) && firmMembershipType.includes(roleId.acronym);
})) === null || _a === void 0 ? void 0 : _a[0][0]; };
exports.isProductForRenewal = (date) => {
    if (date) {
        const currentDate = moment_timezone_1.default().add(6, 'months').format('YYYY-MM-DD');
        const termEndDate = moment_timezone_1.default(date).format('YYYY-MM-DD');
        return currentDate <= termEndDate;
    }
    return false;
};
exports.getPillValueFormat = (sku, types) => {
    var _a;
    const product = types === null || types === void 0 ? void 0 : types.find((type) => sku === (type === null || type === void 0 ? void 0 : type.skus[0]));
    return product ? `${product === null || product === void 0 ? void 0 : product.membershipKey} - ${(_a = product === null || product === void 0 ? void 0 : product.tierCode) === null || _a === void 0 ? void 0 : _a.key}` : '0';
};
//# sourceMappingURL=index.js.map